export default "__VITE_ASSET__68acca93__"